<div class="dialog">
	<div class="modal__header modal__header--warning">
		<h2 *ngIf="modalType === 'paymentAlert' || modalType === 'bookingPaymentAlert'"  class="title" id="modal__title">{{'shoppingBasket.title.paymentAlert' | ibeadmin | async}}</h2>
		<h2 *ngIf="modalType === 'emailAlert'"  class="title" id="modal__title">{{'shoppingBasket.title.emailAlert' | ibeadmin | async}}</h2>
		<div class="modal__header-actions">
			<button aria-label="Close dialog" *ngIf="modalType === 'emailAlert' || modalType === 'paymentAlert'"  (click)="closeModal()">
				<app-svg svg="icons.svg#general--close"></app-svg>
			</button>
		</div>
	</div>
	<div class="modal__body sl--scrollable" *ngIf="modalType === 'paymentAlert' || modalType === 'bookingPaymentAlert'">
		{{'shoppingBasket.text.attemptLimitExceeded' | ibeadmin | async}}
	</div>
	<div class="modal__body sl--scrollable" *ngIf="modalType === 'emailAlert'">
		{{'shoppingBasket.text.addEmailtoProceed' | ibeadmin | async}}
		</div>
	<div class="modal__footer">
		<div class="modal__footer-action negative-action">
			<button *ngIf="modalType === 'emailAlert'" class="button button--small" (click)="closeModal()">{{'shoppingBasket.button.closeEmailAlert' | ibeadmin | async}}</button>
		</div>
		<div class="modal__footer-action positive-action">
			<button *ngIf="modalType === 'paymentAlert' || modalType === 'bookingPaymentAlert'" (click)="actionButton()"
				class="button button--small button-accent button--icon-right">{{'shoppingBasket.button.paymentAlertOk' | ibeadmin | async}}
				<app-svg svg="icons.svg#general--arrow--right"></app-svg></button>
			<button *ngIf="modalType === 'emailAlert'" (click)="actionButton()"
			class="button button--small button-accent">{{'shoppingBasket.button.addEmail' | ibeadmin | async}}</button>
		</div>
	</div>
</div>